export default {
	save: 'Փոփոխությունները հաջողությամբ պահպանվել են',
	error: 'Սխալ: Կապվեք Աջակցության հետ',
	'old password was incorrect': 'Հին գաղտնաբառը սխալ էր',
	templateDuplicated: 'Ձևանմուշը հաջողությամբ կրկնօրինակվեց',

}